"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ATTACHMENT_EXTENSIONS_BY_KIND () {
        return ATTACHMENT_EXTENSIONS_BY_KIND;
    },
    get ATTACHMENT_FILE_NAME_MAX () {
        return ATTACHMENT_FILE_NAME_MAX;
    },
    get ATTACHMENT_KINDS () {
        return ATTACHMENT_KINDS;
    },
    get ATTACHMENT_MAX_BYTES () {
        return ATTACHMENT_MAX_BYTES;
    },
    get ATTACHMENT_MIME_BY_KIND () {
        return ATTACHMENT_MIME_BY_KIND;
    },
    get AttachmentKindSchema () {
        return AttachmentKindSchema;
    }
});
const _zod = require("zod");
const ATTACHMENT_KINDS = [
    'pdf',
    'jpeg',
    'png'
];
const AttachmentKindSchema = _zod.z.enum(ATTACHMENT_KINDS);
const ATTACHMENT_MIME_BY_KIND = {
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    png: 'image/png'
};
const ATTACHMENT_EXTENSIONS_BY_KIND = {
    pdf: [
        'pdf'
    ],
    jpeg: [
        'jpg',
        'jpeg'
    ],
    png: [
        'png'
    ]
};
const ATTACHMENT_MAX_BYTES = 10_485_760;
const ATTACHMENT_FILE_NAME_MAX = 255;
